/* tslint:disable */

declare var Object: any;
export interface ERPpurchasePrepaymentInvoiceInterface {
  "id"?: number;
}

export class ERPpurchasePrepaymentInvoice implements ERPpurchasePrepaymentInvoiceInterface {
  "id": number;
  constructor(data?: ERPpurchasePrepaymentInvoiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchasePrepaymentInvoice`.
   */
  public static getModelName() {
    return "ERPpurchasePrepaymentInvoice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchasePrepaymentInvoice for dynamic purposes.
  **/
  public static factory(data: ERPpurchasePrepaymentInvoiceInterface): ERPpurchasePrepaymentInvoice{
    return new ERPpurchasePrepaymentInvoice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchasePrepaymentInvoice',
      plural: 'ERPpurchasePrepaymentInvoices',
      path: 'ERPpurchasePrepaymentInvoices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchasePrepaymentInvoice.ts